import { createSlice } from "@reduxjs/toolkit/"


let initialState = {
    currentAnnonce: {},
    listAnnonces :[]
}
const annoncesSlice = createSlice({
    name:'annonces',
    initialState,
    reducers:{
        setCurrentAnnonce:(state,{payload})=>{
            state.currentAnnonce = payload
        },
        setAnnoncesList:(state,{payload})=>{
            state.listAnnonces = payload
        },
        removeCurrentAnnonce:(state,{payload})=>{
            state.currentAnnonce = {}
        },
    }
})

export const { setCurrentAnnonce,setAnnoncesList,removeCurrentAnnonce} = annoncesSlice.actions
export default annoncesSlice.reducer